import statRoutes from './routes'

/* @ngInject */
const statRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(statRoutes.index.path, {
      url: statRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'statCtrl',
      redirectTo: statRoutes.home.path,
    })
    .state(statRoutes.home.path, {
      url: statRoutes.home.url,
      template: require('./templates/home.html'),
    })
}

export default statRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/stat/stat.routes.js